import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsTriathlonNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#sports_triathlon_normal_large_svg__clip0_138_140)">
        <path
          d="M30.51 22.02a6.51 6.51 0 000-13.02c-.783 0-1.559.142-2.29.42L25.37 4h3.12l-1.04-1.95.09-.05h-5.48l2.1 4h-4.48l-1.063-2h2.043l-1.07-2H13.6l1.06 2h1.693l1.459 2.746-1.383 2.566a6.491 6.491 0 104.486 7.2h3.165a6.512 6.512 0 006.43 5.508zm-8.571-7.51H15.9l.31-.56v-.01l2.73-5.06v-.01l2.999 5.64zM14.507 20a4.493 4.493 0 110-8.985c.317 0 .634.034.944.1l-1.8 3.343 1.05 2.05h4.179A4.5 4.5 0 0114.507 20zm9.6-5.671L20.743 8h4.467l1.27 2.41a6.447 6.447 0 00-2.37 3.921l-.003-.002zm3.32-2.111L29.42 16h2.26l-2.52-4.8c.438-.133.892-.2 1.35-.2a4.517 4.517 0 11-3.08 1.22l-.003-.002zM47.44 41.83l-6.47-12.09a3.034 3.034 0 00-2.68-1.6 2.989 2.989 0 00-2.69 1.64l-.38.69a1.013 1.013 0 01-.5-.87v-3.43a2.163 2.163 0 00-4.06-1.05l-2.85 5.13-1.56 1.14a3.164 3.164 0 00-1.23 2.38 3.331 3.331 0 001.03 2.66l7.82 7.93a12.546 12.546 0 008.85 3.68h.99a4.227 4.227 0 003.73-6.21zm-1.82 3.13a2.205 2.205 0 01-1.91 1.08h-.99a10.558 10.558 0 01-7.43-3.09l-7.85-7.96a1.331 1.331 0 01-.42-1.1 1.22 1.22 0 01.4-.88l1.92-1.41 3.07-5.51a.156.156 0 01.15-.09.168.168 0 01.16.17v3.43a3.022 3.022 0 003.02 3.01h.6l1.03-1.9a1.022 1.022 0 01.92-.57 1.044 1.044 0 01.92.54l1.76 3.29L38 35.55v2.26l3.91-2.07 1.15 2.14L40 39.5v2.26l4-2.12 1.67 3.13a2.22 2.22 0 01-.05 2.19zM18.99 27.31a3.37 3.37 0 01-3.02-1.81l-.27-.5h-1.39l-.27.5a3.424 3.424 0 01-6.04 0l-.27-.5H6.34l-.27.5a3.368 3.368 0 01-3.02 1.81A3.37 3.37 0 01.03 25.5L0 25.44v2.95a5.4 5.4 0 003.05.92 5.362 5.362 0 003.99-1.73 5.444 5.444 0 007.96 0 5.364 5.364 0 003.99 1.73 5.458 5.458 0 003.01-.89v-2.9a3.367 3.367 0 01-3.01 1.79zm0 8.99a3.36 3.36 0 01-3.02-1.82l-.27-.5h-1.39l-.27.5a3.416 3.416 0 01-6.04 0l-.27-.5H6.34l-.27.5a3.36 3.36 0 01-3.02 1.82 3.36 3.36 0 01-3.02-1.82L0 34.42v2.95a5.336 5.336 0 003.05.93 5.336 5.336 0 003.99-1.74 5.422 5.422 0 007.96 0 5.46 5.46 0 007 .84v-2.9a3.356 3.356 0 01-3.01 1.8zm0 9.01a3.333 3.333 0 01-3.02-1.81l-.27-.5h-1.39l-.27.5a3.424 3.424 0 01-6.04 0l-.27-.5H6.34l-.27.5a3.351 3.351 0 01-3.02 1.81A3.333 3.333 0 01.03 43.5L0 43.44v2.95a5.255 5.255 0 003.05.92 5.327 5.327 0 003.99-1.73 5.253 5.253 0 003.98 1.73A5.291 5.291 0 0015 45.58a5.292 5.292 0 003.99 1.73 5.458 5.458 0 003.01-.89v-2.9a3.347 3.347 0 01-3.01 1.79z"
          fill=""
        />
      </g>
      <defs>
        <clipPath id="sports_triathlon_normal_large_svg__clip0_138_140">
          <path fill="#fff" d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
SvgSportsTriathlonNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsTriathlonNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsTriathlonNormalLarge;
